exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-presentation-tsx": () => import("./../../../src/pages/presentation.tsx" /* webpackChunkName: "component---src-pages-presentation-tsx" */),
  "component---src-pages-profile-tsx": () => import("./../../../src/pages/profile.tsx" /* webpackChunkName: "component---src-pages-profile-tsx" */),
  "component---src-templates-work-detail-tsx": () => import("./../../../src/templates/work-detail.tsx" /* webpackChunkName: "component---src-templates-work-detail-tsx" */)
}

